<template>
  <div class="public-content theme-management">
    <div class="region-title" style="background: #fff">收选片角色</div>
    <div class="add-category">
      <el-button round type="primary" @click="add">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border>
        <el-table-column prop="attrName" label="收选片角色"> </el-table-column>
        <el-table-column prop="isAdmin" label="是否为管理员">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isAdmin" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"
              @change="changeAdmin($event,scope)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="color-blue" style="margin-right:5px" @click="edit(scope)">编辑</span>
            <span class="color-blue" @click="del(scope)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <addEditDialogVue ref="addEditDialogVue" @success="onSubmit"></addEditDialogVue>

  </div>
</template>
<script>
import addEditDialogVue from './addEditDialog.vue'
import { adminModuleAttributeList, adminModuleAttributeUpdate, adminModuleAttributeDel, adminModuleAttributeAdd } from '@/api/auxx.js'
export default {
  components: {
    addEditDialogVue
  },
  data () {
    return {

      addDialog: false,
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    onSubmit () {
      adminModuleAttributeList()
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data
          }
        })
    },
    changeAdmin (e, scope) {
      console.log(e, scope)
      let vo = JSON.parse(JSON.stringify(scope.row))
      adminModuleAttributeUpdate(vo)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
          }
        })
    },
    add () {
      this.$refs.addEditDialogVue.show(false)
    },
    edit (scope) {
      let vo = JSON.parse(JSON.stringify(scope.row))
      this.$refs.addEditDialogVue.show(true, vo)
    },

    del (scope) {
      adminModuleAttributeDel(scope.row.attrId)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.onSubmit()
          }
        })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
</style>
